
import Passenger from "@/components/Passenger/models/Passenger";
import { Component, Vue } from "vue-property-decorator";
import DateTimePicker from "@/components/DatetimePicker.vue";
import Trip from "@/components/Passenger/models/Trip";
import restService from "@/services/restService";
import vuetifyToast from "vuetify-toast";
import RouteDetails from "@/components/RouteDetails.vue";
import RouteWithTrips from "@/components/Passenger/models/RouteWithTrips";
import moment from "moment";

@Component({
    components: {
        DateTimePicker,
        RouteDetails,
    },
})
export default class DestinationTripList extends Vue {
    tripsStartDate: string = new Date().toISOString().substr(0, 10);
    tripsEndDate: string = new Date().toISOString().substr(0, 10);
    tripsForPassengers: Trip[] = [];
    selectedRoute: RouteWithTrips | null = null;
    selectedTripId: number | null = null;
    loadingTrips: boolean = false;
    selectedDayTab: string | null = null;
    loadingTextFetchedPassengersCount: number = 0;
    search: string = '';
    loadingRouteDetails: boolean = false;

    get destinationPassengers(): Passenger[] {
        const destinationId = this.$route && this.$route.params && this.$route.params.destinationId ? this.$route.params.destinationId : 'ei param';
        return this.$store.getters['passenger/getPassengersForDestination'](destinationId);
    }

    get destinationId(): number {
        return this.$route && this.$route.params && this.$route.params.destinationId ? parseInt(this.$route.params.destinationId, 10) : null;
    }

    get tripHeaders(): any[] {
        return [
        {
            text: this.$i18n.translate("arrival_departure.date-picker.label", "Date"),
            align: "left",
            sortable: true,
            value: "tripDate"
        },
        {
            text: this.$i18n.translate("passenger.prop.name.label", "Name"),
            align: "left",
            sortable: true,
            value: "passengerName"
        },
        {
            text: this.$i18n.translate("passenger.prop.trips.startPlace", "Start place"),
            align: "left",
            sortable: true,
            value: "startPlace"
        },
        {
            text: this.$i18n.translate("passenger.prop.trips.endPlace", "End place"),
            align: "left",
            sortable: false,
            value: "endPlace"
        },
        {
            text: this.$i18n.translate("passenger.prop.trips.startTime", "Start time"),
            align: "left",
            sortable: true,
            value: "startDateTime"
        },
        {
            text: this.$i18n.translate("passenger.prop.trips.endTime", "End time"),
            align: "left",
            sortable: true,
            value: "endDateTime"
        },
        {
            text:this.$i18n.translate("generic.car", "Car"),
            align: "left",
            sortable: false,
            value: "carName"
        }
        ];
    }

    get loadingText() {
        return this.loadingTrips ? this.$t('timetable.trip_list.loading', { count: this.loadingTextFetchedPassengersCount, length: this.destinationPassengers.length }) : this.$t('timetable.trip_list.no_trips','No trips');
    }

    get sortedTrips(): Trip[] {
        if(this.loadingTrips) {
            return [];
        }

        const sortedTrips = this.tripsForPassengers.slice().sort((a, b) => {
            const dateA = new Date(a.startDateTime ? a.startDateTime : a.endDateTime);
            const dateB = new Date(b.startDateTime ? b.startDateTime : b.endDateTime);
            if (dateA.getTime() < dateB.getTime()) return -1;
            if (dateA.getTime() > dateB.getTime()) return 1;
            return 0;
        });

        if(this.search) {
            return sortedTrips.filter(trip => {
                const passengerName = trip.passenger && trip.passenger.name ? trip.passenger.name.toLowerCase() : '';
                return passengerName.includes(this.search.toLowerCase());
            });
        }
        return sortedTrips;
    }

    async openRouteDetails(trip: any) {
      this.selectedRoute = await this.getRouteDetailsForTrip(trip);
      if (!this.selectedRoute) {
          vuetifyToast.info(this.$t('routeDetails.tripHasNoRoute'));
          return;
      }
      this.selectedTripId = trip.id;
    }


    async updateRouteDetails(trip: Trip) {
      if (!trip) {
        return;
      }
      this.selectedRoute = await this.getRouteDetailsForTrip(trip);
    }

    async getRouteDetailsForTrip(trip: Trip) {
      const tripDate = moment(trip.startDateTime || trip.endDateTime).format("YYYY-MM-DD");
      try {
        this.loadingRouteDetails = true;
        return await restService.passengers.getPassengerRouteWithTrips(trip.passenger.timitId, trip.id, tripDate);
      } finally {
        this.loadingRouteDetails = false;
      }
    }       



    async getPassengerTrips() {
        this.loadingTrips = true;
        this.tripsForPassengers = [];
        for (const passenger of this.destinationPassengers) {
            try {
                this.loadingTextFetchedPassengersCount++;
                const trips = await this.fetchTripsForPassenger(passenger);
                this.tripsForPassengers.push(...trips);
            } catch (error) {
                console.error("Error fetching trips for passenger", passenger.id, error);
            }
        }
        this.loadingTextFetchedPassengersCount = 0;
        this.loadingTrips = false;
    }

    async fetchTripsForPassenger(passenger: Passenger) {
        return await restService.passengers.getPassengerTrips(
            passenger.id,
            this.tripsStartDate,
            this.tripsEndDate,
            this.destinationId,
        );
    }
    

    startDateUpdated(value) {
        this.tripsStartDate = value;
        if (value > this.tripsEndDate) {
            this.tripsEndDate = value;
        }
        const maxEnd = new Date(value);
        maxEnd.setMonth(maxEnd.getMonth() + 1);
        if (new Date(this.tripsEndDate).getTime() > maxEnd.getTime()) {
            this.tripsEndDate = maxEnd.toISOString().substr(0, 10);
        }
    }

    endDateUpdated(value) {
        this.tripsEndDate = value;
        if (value < this.tripsStartDate) {
            this.tripsStartDate = value;
        }
        const minStart = new Date(value);
        minStart.setMonth(minStart.getMonth() - 1);
        if (new Date(this.tripsStartDate).getTime() < minStart.getTime()) {
            this.tripsStartDate = minStart.toISOString().substr(0, 10);
        }
    }

    closeRouteDetails() {
        this.selectedRoute = null;
        this.selectedTripId = null;
    }
}
